import React, { Component, Fragment } from 'react';

class AwaveConfirm extends Component {
	render() {
		const {
			confirmCancel,
			confirmOk
		} = this.props;
		const {id, notice, labelOk, labelCancel} = this.props.data;
		
		let confirmId = id ? id : "awave-confirm-window";

		document.onkeydown = function(evt) {
			evt = evt || window.event;
			if (evt.keyCode === 27) {
				confirmCancel(evt);
			}
		};

		return (
			<Fragment>
				<div className="confirm-background" onClick={(e) => confirmCancel(e)}></div>
				<div id={confirmId} className="confirm-window">
					<div className="confirm-window--inner">
						<div className="confirm-window--content">
							<div className="confirm-window--content--notice">{notice}</div>
							<div className="confirm-window--content--buttons">
								<button className="cancel-button" onClick={(e) => confirmCancel(e)}>{labelCancel}</button>
								<button className="confirm-btn" onClick={(e) => confirmOk(e)}>{labelOk}</button>
							</div>
						</div>
					</div>
				</div>
			</Fragment>
		)
	}
}

export default AwaveConfirm;


// WEBPACK FOOTER //
// ./src/frontend/components/UI/AwaveConfirm.js